import { css } from 'lit';

export const textFieldStyles = css`
  :host(.filled) {
    background: var(--token-component-text-field-filled-background, light-dark(#ffffff, #343438));
    border: 1px solid var(--token-component-text-field-filled-border, light-dark(#83838c, #696970));
  }

  :host {
    align-items: center;
    background: var(--token-component-text-field-default-background, light-dark(#ffffff, #343438));
    border: 1px solid var(--token-component-text-field-default-border, light-dark(#83838c, #696970));
    box-sizing: border-box;
    display: flex;
    flex: 1 0 0;
    gap: var(--token-global-spacing-s12, 12px);
    height: 34px;
    padding: var(--token-global-spacing-s8, 8px) var(--token-global-spacing-s8, 8px) var(--token-global-spacing-s8, 8px) var(--token-global-spacing-s12, 12px);

    input[type='text'],
    input[type='password'] {
      appearance: none;
      background: none;
      border: none;
      box-sizing: border-box;
      color: var(--token-component-text-field-focus-text, light-dark(#343438, #ffffff));
      flex: 1 0 0;
      font-family: var(--token-global-font-font-family-brand, 'Nunito Sans');
      font-size: var(--token-global-font-font-size-xs, 0.875rem); /* 14px */
      font-style: normal;
      font-weight: var(--token-global-font-font-weight-regular-normal, 400);
      line-height: var(--token-global-font-line-height-xxxs, 1rem); /* 16px */;
      height: var(--token-global-spacing-s16, 16px);
      margin: 0;
      outline: none;
      overflow: hidden;
      padding: 0;
      text-overflow: ellipsis;
      white-space: nowrap;    
    }
    input[type='text']::placeholder,
    input[type='password']::placeholder {
      color: var(--token-component-text-field-placeholder-text, light-dark(#696970, #a3a3ab));
      font-style: italic;
    }
  }

  :host(:hover) {
    border: 1px solid var(--token-component-text-field-hover-empty-border, light-dark(#3d3d42, #c2c2ca));
    background: var(--token-component-text-field-hover-empty-background, light-dark(#ffffff, #343438));

    input[type='text']::placeholder,
    input[type='password']::placeholder {
      color: var(--token-component-text-field-hover-empty-text, light-dark(#696970, #a3a3ab));
    }
  }

  :host(:focus), :host(:active) {
    background: var(--token-component-text-field-focus-background, light-dark(#ffffff, #343438));
    border: 1px solid var(--token-component-text-field-focus-border, light-dark(#0174bc, #5bb3ea));

    input[type='text'],
    input[type='password'] {
      color: var(--token-component-text-field-focus-text, light-dark(#343438, #ffffff));
    }
  }

  :host([disabled]) {
    background: var(--token-component-text-field-disabled-background, light-dark(#ededf2, #515157));
    border: 1px solid var(--token-component-text-field-disabled-border, light-dark(#c2c2ca, #515157));
    color: var(--token-component-text-field-disabled-text, light-dark(#a3a3ab, #83838c));
    cursor: not-allowed;

    input[type='text'],
    input[type='password'] {
      color: var(--token-component-text-field-disabled-text, light-dark(#a3a3ab, #83838c));
      cursor: not-allowed;
    }
  }

  :host(:invalid), :host(.error) {
    background: var(--token-component-text-field-error-background, light-dark(#ffffff, #343438));
    border: 1px solid var(--token-component-text-field-error-border, light-dark(#d63c42, #eb9091));
  }

  :host([readonly]) {
    background: transparent;
    border: none;
  
    .readonly-container {
      cursor: default;
      color: var(--token-component-text-area-read-only-text, light-dark(#343438, #ffffff));
      display: inline-block;
      min-width: 184px;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }
`;
